import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useSportContent } from '../hooks/useSportContent';

const FundamentalsScreen: React.FC = () => {
  const { currentSport } = useTheme();
  const { content, loading, error } = useSportContent(currentSport.id);

  if (loading) {
    return (
      <div className="fundamentals-screen">
        <div className="container">
          <h1>Loading {currentSport.name} Fundamentals...</h1>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="fundamentals-screen">
        <div className="container">
          <h1>Error Loading Fundamentals</h1>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  const fundamentals = content?.fundamentals ?? [];

  return (
    <div className="fundamentals-screen">
      <div className="container">
        <h1>{currentSport.name} Fundamentals</h1>
        <div className="fundamentals-grid">
          {fundamentals.map((fundamental) => {
            const f = fundamental as { content?: string[]; steps?: string[]; category?: string; importance?: string; practiceTips?: string[] };
            const points = f.content ?? f.steps ?? [];
            const category = f.category ?? f.importance ?? 'Technique';
            return (
              <div key={fundamental.id} className="fundamental-card">
                <h3>{fundamental.title}</h3>
                <p>{fundamental.description}</p>
                <div className="fundamental-meta">
                  <span className="category">{category}</span>
                </div>
                {points.length > 0 && (
                  <div className="fundamental-content">
                    <strong>Key Points:</strong>
                    <ul>
                      {points.map((point, index) => (
                        <li key={index}>{point}</li>
                      ))}
                    </ul>
                  </div>
                )}
                {f.practiceTips?.length > 0 && (
                  <div className="fundamental-content">
                    <strong>Practice Tips:</strong>
                    <ul>
                      {f.practiceTips.map((tip, index) => (
                        <li key={index}>{tip}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FundamentalsScreen;
